export default function WelcomeController() {

}